import { AutoComplete, Button, Input, Select, Tag } from 'antd'
import { get } from 'lodash'

import ViewIcon from '@assets/icons/viewSvg.jsx'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'

const ClientOrderInfoSection = ({
	t,
	loadingClient,
	clientName,
	setClientName,
	handleCardNameChange,
	clientsData,
	setClientCode,
	setIsModalVisible,
	currency,
	setCurrency,
	roleNames,
	departmentAdmin,
	setDepartmentAdmin,
	departmentLoading,
	departmentData,
	slpCode,
	setSlpAdmin,
	slpLoading,
	slpData,
	dateSale,
	setDateSale,
	whs,
	setWhs,
	whsLoading,
	warehouseData,
	bpDebt,
	clientCode,
	setIsViewBpBalanceModalVisible,
}) => (
	<>
		<div className="flex items-center gap-10 flex-wrap">
			<div className={'flex items-end'}>
				<div className="flex flex-col items-start gap-3 ">
					<p className="font-nunito">{t('Client')}</p>
					<AutoComplete
						loading={loadingClient}
						showSearch
						value={clientName}
						className=" w-[300px]"
						onSelect={(value) => {
							const val = value.split(' ,/ ')[0]

							setClientName(val)
							handleCardNameChange(val)
							const selectedOption = clientsData.find(
								(client) => {
									const cardName = get(
										client,
										'cardName',
										'',
									)
									const cardCode = get(
										client,
										'cardCode',
										'',
									)
									const phoneNumber = get(
										client,
										'Cellular',
										'',
									)
										? get(client, 'Cellular', '')
										: ''
									const formattedValue = [
										cardName,
										phoneNumber,
									]
										.filter(Boolean)
										.join(' ')
									return (
										`${formattedValue} ,/ ${cardCode}` ===
										value
									)
								},
							)

							if (selectedOption) {
								const cardCode = get(
									selectedOption,
									'cardCode',
									'',
								)
								setClientCode(cardCode)
							}
						}}
						onChange={(val) => {
							const value = val.split(' ,/ ')[0]
							setClientName(value)
							handleCardNameChange(value)
						}}
						options={clientsData.map((client) => ({
							value: `${client.cardName}${client.Cellular ? ` ${client.Cellular}` : ''} ,/ ${client.cardCode}`,
							label: (
								<div className="flex items-center justify-between">
									<p>{client.cardName}</p>
									{client.Cellular && (
										<Tag
											color="blue"
											className="text-[9px]"
										>
											{client.Cellular}
										</Tag>
									)}
								</div>
							),
						}))}
					/>
				</div>
				<button
					className="w-[30px] h-8 bg-blue-700 text-white text-lg hover:bg-blue-500"
					onClick={() => setIsModalVisible(true)}
				>
					+
				</button>
			</div>
			<div className="flex flex-col gap-2">
				<p>{t('currency')}</p>
				<div className="flex">
					<Select
						value={currency}
						onChange={(value) => setCurrency(value)}
						className="w-[150px]"
						disabled
					>
						<Select.Option key={1} value={'UZS'}>
							UZS
						</Select.Option>
						<Select.Option key={1} value={'USD'}>
							USD
						</Select.Option>
					</Select>
				</div>
			</div>
			{roleNames.includes('admin') && (
				<div className="flex flex-col gap-2">
					<p>{t('departmentName')}</p>
					<div className="flex">
						<Select
							value={departmentAdmin}
							className="flex h-8  w-[150px] items-center justify-center "
							style={{ color: 'black' }}
							onChange={(val) => {
								setDepartmentAdmin(val)
							}}
							loading={departmentLoading}
							options={departmentData.map(
								(department) => {
									return {
										label: department.name,
										value: Number(department.code),
									}
								},
							)}
							filterOption={(input, option) =>
								option.label
									.toLowerCase()
									.includes(input.toLowerCase())
							}
							showSearch
						/>
					</div>
				</div>
			)}
			{roleNames.includes('admin') && (
				<div className="flex flex-col gap-2">
					<p>{t('slpName')}</p>
					<Select
						value={slpCode}
						className="flex h-8  w-[150px] items-center justify-center "
						style={{ color: 'black' }}
						onChange={(val) => {
							setSlpAdmin(val)
						}}
						loading={slpLoading}
						options={slpData.map((slp) => {
							return {
								label: slp.slpName,
								value: Number(slp.slpCode),
							}
						})}
						filterOption={(input, option) =>
							option.label
								.toLowerCase()
								.includes(input.toLowerCase())
						}
						showSearch
					/>
				</div>
			)}
			{roleNames.includes('admin') && (
				<div className="flex flex-col gap-2">
					<p>{t('date')}</p>
					<Input
						type="date"
						value={dateSale}
						onChange={(e) => setDateSale(e.target.value)}
						className="w-full"
					/>
				</div>
			)}
			{roleNames.includes('admin') && (
				<div className="flex flex-col gap-2">
					<p>{t('whs')}</p>
					{/* <Spin spinning={whsLoading}> */}
					<Select
						value={whs}
						onChange={(value) => setWhs(value)}
						className="w-[200px] "
						loading={whsLoading}
						options={warehouseData.map((warehouse) => ({
							label: warehouse.name,
							value: warehouse.code,
						}))}
						filterOption={(input, option) =>
							option.label
								.toLowerCase()
								.includes(input.toLowerCase())
						}
						showSearch
					/>
					{/* </Spin> */}
				</div>
			)}
		</div>

		<div className="flex items-end gap-2 mt-5 ">
			<div className="flex flex-col gap-2">
				<p>{t('bpDebt')}</p>
				<Input
					value={
						clientCode
							? `${numberWithSpacesIntl(bpDebt) || 0} USD`
							: ''
					}
					className="w-[200px] "
					disabled
				/>
			</div>
			<Button
				type="primary"
				onClick={() => setIsViewBpBalanceModalVisible(true)}
				disabled={!clientCode}
				className="bg-blue-700 text-white rounded-lg  hover:bg-blue-500 disabled:bg-blue-300"
			>
				<ViewIcon />
			</Button>
		</div>
	</>
)

export default ClientOrderInfoSection
